// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    export enum Business {
  Automation = 65,
  Fire = 70,
  Security = 83,
  ServiceAgreement = 84,
  Electrical = 69,
  Mechanical = 77,
}
